import { Model } from 'app/model/backendmodel';
import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';
import { Owned } from 'app/model/base/named';
import { Activity } from 'app/model/pipeline/activity';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { FileTypeSinkAdapter } from 'app/model/adapters/activities/copysink/file-type.sink.adapter';
import { AzureBlobFSSink } from 'app/model/pipeline/copysink/azure-blob-fs.copysink';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureBlobFSSink),
    asynchronous: true,
    adapts: {
        type: '*',
        copyBehavior: '*',
        maxConcurrentConnections: '*',
        structure: '*'
    }
})
export class AzureBlobFSSinkAdapter extends CopySinkAdapter<AzureBlobFSSink, Model.AzureBlobFSSink> {
    protected override async _toResource(model: AzureBlobFSSink): Promise<Model.BlobSink> {
        const result: Model.AzureBlobFSSink = {
            type: Metamodel.modelFor(AzureBlobFSSink).name
        };
        FileTypeSinkAdapter.toSinkResource(model, result);
        CopySinkAdapter.toCommonCopySinkResource(model, result, this.context);
        return result;
    }

    protected override async _toModel(resource: Model.AzureBlobFSSink, owner: Activity): Promise<AzureBlobFSSink> {
        const result = Owned.create<AzureBlobFSSink>(Metamodel.modelFor(AzureBlobFSSink), owner);
        FileTypeSinkAdapter.toSinkModel(resource, result);
        CopySinkAdapter.toCommonCopySinkModel(result, resource);
        return result;
    }
}
